import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'

import { isSafari } from '../../../../utils/device'
import SimpleModal from '../../../common/SimpleModal'
import { filesBaseUrl } from '../../utils'

const mainVideo = `${filesBaseUrl}/asset_sito/videos/lucidatura.mp4`

const VasPolishingModal = ({ show, onClose, modalTitle }) => {
  const videoParentRef = useRef()
  const [shouldUseImage, setShouldUseImage] = useState(false)
  useEffect(() => {
    // check if user agent is safari
    if (isSafari()) {
      // obtain reference to the video element
      const player = videoParentRef.current?.children[0]

      // if the reference to video player has been obtained
      if (player) {
        // set the video attributes using javascript as per the
        // webkit Policy
        player.controls = false
        player.playsinline = true
        player.muted = true
        player.setAttribute('muted', '') // leave no stones unturned :)
        player.autoplay = true

        // Let's wait for an event loop tick and be async.
        setTimeout(() => {
          // player.play() might return a promise but it's not guaranteed crossbrowser.
          const promise = player.play()
          // let's play safe to ensure that if we do have a promise
          if (promise.then) {
            promise
              .then(() => {})
              .catch(() => {
                // if promise fails, hide the video and fallback to <img> tag
                videoParentRef.current.style.display = 'none'
                setShouldUseImage(true)
              })
          }
        }, 0)
      }
    }
  }, [])

  return (
    <SimpleModal onClose={onClose} show={show} title={modalTitle}>
      {shouldUseImage ? (
        <img alt="Muted Video" src={mainVideo} />
      ) : (
        <div
          dangerouslySetInnerHTML={{
            __html: `
            <video width="100%" height="100%" loop autoplay="autoplay" muted playsinline preload="metadata">
            <source
              src=${mainVideo}
              type="video/mp4"
            />
          </video>`,
          }}
          ref={videoParentRef}
        />
      )}
    </SimpleModal>
  )
}

VasPolishingModal.defaultProps = {
  onClose: () => {},
  show: false,
  modalTitle: null,
}

VasPolishingModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  modalTitle: PropTypes.string,
}

export default VasPolishingModal
